import type { SchedulePreviewOpeningHours } from 'lib-shared-types-api';

type ScheduleMap = Record<string, SchedulePreviewOpeningHours[]>;

export const getSchedulesForMonthAndDay = (
  schedule: ScheduleMap,
  month: number,
  day: number,
): SchedulePreviewOpeningHours[] => schedule[`${month}/${day}`] || [];
